import { Button, Container, LoadingOverlay, Stepper, Text, Title } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import React, { useCallback, useRef, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import Webcam from 'react-webcam';
import ChevronLeftIcon from '../../assets/ChevronLeftIcon';
import CloseIcon from '../../assets/CloseIcon';
import ErrorCamera from '../../assets/errorCamera.svg';
import RotateCameraIcon from '../../assets/RotateCameraIcon';
import useFirebaseFunction from "../../utils/useFirebaseFunction";
import AppLoadingAnimation from "../AppLoadingAnimation";

export default function SelfieModal({onClose, board}) {
    const [loading, setLoading] = useState(true);
    const [search_upload] = useFirebaseFunction("search_upload", "europe-west1");
    const [active, setActive] = useState(1);
    const [photoTaken, setPhotoTaken] = useState(null)
    const [error,setError] = useState(null);

    const { height:heightViewSize } = useViewportSize();

    const webcamRef = useRef(null);
    const FACING_MODE_USER = "user";
    const FACING_MODE_ENVIRONMENT = "environment";

    const [facingMode, setFacingMode] = useState({exact: "user"});

    // const onTakePhoto = (dataUri) => {
    //     setPhotoTaken(dataUri);
    //     setActive(2)
    // }
    const onTakePhoto = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setPhotoTaken(imageSrc);
        setActive(2);
    },[webcamRef]);

    const handleSwitchCamera = useCallback(() => {
        setFacingMode(
          prevState =>
            prevState === FACING_MODE_USER
              ? FACING_MODE_ENVIRONMENT
              : FACING_MODE_USER
        );
      }, []);

    const retakeSelfie = () => {
        setActive(1);
    }

    const confirmPhoto = () => {
        setLoading(true);
        search_upload({selfie: photoTaken, board})
        .then(() => {
            setLoading(false);
            window.location.reload();
            onClose();
        })
    }

    const onError = (error) => {
        setError(error);
    }

    const videoConstraints = useCallback(() => {
        return (
            {
                //height: heightViewSize,

                facingMode: facingMode
            }
        )
    }, [heightViewSize, facingMode]);

    const stepperStyles = {
        separator: {
            width:'53px',
            background: '#fff',
            marginBottom:'12px',
            marginLeft:'-6px',
            marginRight:'-14px'
        },
        separatorActive: {
            background:'#fff',
        },
        stepLabel: {
            color:'#fff',
            marginTop:'4px',
            fontSize:'9px',
        },
        stepIcon: {
            background: '#fff0',
            borderColor:'#fff !important',
            height: '15px',
            width: '15px',
            minWidth:'15px'
        },
        stepCompletedIcon: {
            background: '#fff',
            borderRadius:'4px',
        },
        step: {
            flexDirection:'column'
        },
        stepProgress:{
            flexDirection:'column',
        },
        stepBody: {
            marginLeft:'0px'
        }
    }

    if (error) {
        return (
        <Container fluid={true} className={'mt-10 w-full'} style={{height:heightViewSize+'px'}} id="contentGallery">
            <div className="w-full flex justify-center flex-col items-center mt-20">
                <div className="w-full max-w-[150px] mx-auto">
                    <img src={ErrorCamera} alt="error" className="w-full h-full" />
                </div>
                <Title align="center" style={{marginBottom:'0.5rem',color:'#3c3c3c',marginTop:'1rem'}} order={3}>Nu am putut accesa camera</Title>
                <Text align="center" style={{marginBottom:'1.5rem',color:'#3c3c3c', lineHeight:'20px',fontSize:'14px'}}>Nu avem acces la camera ta, te rugam să ne permiti accesul pentru a putea face un selfie. Verifică in setarile telefonului sau a browser-ului.</Text>
                <Button color="dark" onClick={onClose}>Înapoi</Button>
            </div>
        </Container>
        )
    }


    return (
        <>
            <div className="relative bg-black" style={{'--heightViewSize': heightViewSize+'px'}}>
                {loading && <LoadingOverlay style={{height:heightViewSize+'px', width:'100%',zIndex:'99999'}} overlayOpacity={1} visible={true} loader={<AppLoadingAnimation type="camera" />}/>}
                <div className="absolute top-0 w-full h-10 z-10 grid items-center grid-cols-3 glassyBackground">
                    {(active === 2) &&
                        <div onClick={retakeSelfie} className="flex pl-3 py-2 items-center">
                            <ChevronLeftIcon fill="white" width={20} height={20} /> 
                            <span className="text-sm font-[500] text-white">Reluați</span>
                        </div>
                    }
                    <div className="flex justify-center items-center" style={{gridColumn:'2/3'}}>
                        <Stepper
                            className="pointer-events-none"
                            styles={stepperStyles} 
                            completedIcon={<div></div>}
                            iconSize={20} 
                            size="xs" 
                            orientation="horizontal" 
                            active={active} 
                        >
                            <Stepper.Step allowStepClick={false} allowStepSelect={false} icon={<div></div>} label="Selfie"></Stepper.Step>
                            <Stepper.Step allowStepClick={false} allowStepSelect={false} icon={<div></div>} label="Confirma"></Stepper.Step>
                        </Stepper>
                    </div>
                    <div style={{gridColumn:'3/3'}} className="top-0 right-0 z-10 flex justify-end items-center">            
                        <div onClick={onClose} className="px-3 py-2">
                            <CloseIcon width={25} height={25} fill="white" />
                        </div>
                    </div>
                </div>
               
                {active === 1 && 
                <>
                    <Webcam
                        mirrored={true}
                        audio={false}
                        ref={webcamRef}
                        minScreenshotHeight={1000}
                        onError={(error) => onError(error)}
                        // onError={(error) => onError(error)}
                        onUserMediaError={(error) => onError(error)}
                        style={{objectFit:'cover'}}
                        onLoadStart={() => setLoading(false)}
                        className="camera-react"
                        screenshotFormat="image/jpeg"
                        screenshotQuality={100}
                        videoConstraints={{...videoConstraints, facingMode}}
                    />
                    <div onClick={onTakePhoto} className="capture-button-outline">
                        <div className="capture-button-inside">   
                        </div>
                    </div>
                    <div className="rotateCamera" onClick={handleSwitchCamera}>
                        <RotateCameraIcon width={20} height={20} fill="white" />
                    </div>
                </>
                }
                {active === 2 && 
                <>
                    <img alt="picSelfie" style={{width: '100%', objectFit:'cover', height:heightViewSize+'px'}} src={photoTaken}/>
                    <div onClick={confirmPhoto} style={{background:'#3c3c3c', borderRadius:'50%', width:'80px', height:'80px',position:'absolute',bottom:'25px', left:'50%', transform:'translateX(-50%)',display:'flex', justifyContent:'center', alignItems:'center'}}>
                        <svg width={35} height={35} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" fill="white"/></svg>
                    </div>
                </>
                }
            </div>

        </>
    )
}